import React from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'
import Isvg from 'react-inlinesvg'

import { localize } from 'helpers/translator'
import MainButton from 'components/button/main/main_button'
import CountdownTimer from 'views/countdown/countdown_timer/countdown_timer'

import styles from './TeacherHeader.scss'

import MPIcon from 'assets/views/slides/activities/mp-icon-white.svg'

const TeacherHeader = props => (
	<div styleName='TeacherHeader'>
		<div styleName='icon'>
			<Isvg src={MPIcon} cacheGetRequests={true} />
		</div>
		<h1 styleName='title' title={props.title}>{props.title}</h1>
		<div styleName='buttonbar'>
			<div styleName='button'>
				{props.timer.active && <CountdownTimer
					timer={props.timer}
					canStart={true}
				/>}
			</div>
			<div styleName='button'>
				<MainButton styleName='button' bgColor='blue' fontColor='white' onClick={props.onClickViewPairs}>{localize('matching_pairs_dashboard_view_pairs')}</MainButton>
			</div>
		</div>
	</div>
)

TeacherHeader.propTypes = {
	title: PropTypes.string.isRequired,
	onClickViewPairs: PropTypes.func.isRequired,
}

TeacherHeader.defaultProps = {
	title: '',
}

export default CSSModules(TeacherHeader, styles, { allowMultiple: true })
